module.exports = __webpack_public_path__ + "img/20190613162437067.a63abc6a.png";